import React from "react";
import DeviceInterface from "../../interfaces/DeviceInterface";
import GroupInterface from "../../interfaces/GroupInterface";
import { useDeviceGroupStore } from "../../store/device-group/DeviceGroupStore";
import { useLoading } from "../../store/loading/LoadingContextStore";

function DeviceAutoMoveController({
  device,
  group,
  close,
}: {
  device: DeviceInterface;
  group: GroupInterface;
  close: Function;
}) {
  const processingAsyncFn = useLoading();
  const { saveDeviceGroup } = useDeviceGroupStore();

  React.useEffect(() => {
    setTimeout(async () => {
      try {
        await processingAsyncFn(async () => {
          if (await saveDeviceGroup(device.id, device.type, group?.id)) {
            close();
          }
        });
      } catch (e) {
        console.error("Device automove error", e);
      }
    }, 0);
  }, [
    close,
    device.groupId,
    device.id,
    device.type,
    group?.id,
    processingAsyncFn,
    saveDeviceGroup,
  ]);

  return null;
}

export default DeviceAutoMoveController;
